import { signInErrorKey } from "@vd/ui";
import { z } from "zod";

const b64url = /^[A-Za-z0-9_-]+$/;
export const signInSearch = z.object({
  redirect: z.string().optional().catch(undefined),
  error: z.unknown().transform(signInErrorKey).optional(),
  email: z.string().max(254).optional().catch(undefined),
  handoff: z.string().length(43).regex(b64url).optional().catch(undefined),
  port: z.coerce.number().int().min(1024).max(65535).optional().catch(undefined),
  state: z.string().max(128).regex(b64url).optional().catch(undefined),
});

/** Compare the real address, not only the router's validated search state. */
export function canonicalSignInSearch(href: string, input: unknown) {
  const search = signInSearch.parse(input);
  const url = new URL(href, "https://signin.invalid");
  const fields = Object.entries(search).filter(([, value]) => value !== undefined);
  const replace =
    url.hash !== "" ||
    [...url.searchParams].length !== fields.length ||
    fields.some(
      ([key, value]) =>
        url.searchParams.getAll(key).length !== 1 || url.searchParams.get(key) !== String(value),
    );
  return { search, replace };
}
